import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import LoginService from "../../service/LoginService";
import { rememberFedernetReturn } from "../../utilities/federnet";
import localeText from "../../locale";
import "./Login.css";

/**
 * Entrada vinda da Federnet: o usuário que ativou a Extraconomy clica em "Vai su Extraconomy" e chega aqui com um
 * código de uso único (60 segundos). Trocamos o código pelo token, gravamos a sessão como o Login.js e abrimos o painel.
 */
const FedernetHandoff = () => {
  const location = useLocation();
  const [failed, setFailed] = useState(false);
  // O código só vale uma vez: em desenvolvimento o React executa o efeito duas vezes
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    // Domínio próprio do WL de onde o usuário veio, para o "Voltar" (só vem quando não é federnet.it)
    const back = params.get("back");
    if (!code) {
      setFailed(true);
      return;
    }

    // Tira o código da barra de endereço e do histórico
    window.history.replaceState(null, "", location.pathname);

    const exchange = async () => {
      try {
        const res = await new LoginService().exchangeFedernetHandoff(code);
        const result = res?.result ?? res;
        if (!result?.token || !result?.username) {
          setFailed(true);
          return;
        }
        localStorage.setItem("__extraconomy_token", result.token);
        localStorage.setItem("__extraconomy_username", result.username);
        await rememberFedernetReturn(back);
        window.location.replace("/dashboard");
      } catch (e) {
        console.error("Federnet handoff failed:", e);
        setFailed(true);
      }
    };
    exchange();
  }, [location.pathname, location.search]);

  return (
    <div
      className="flex flex-column align-items-center justify-content-center gap-3 p-4 text-center"
      style={{ minHeight: "100vh" }}
    >
      {failed ? (
        <>
          <h2 className="m-0">{localeText("federnetHandoffErrorTitle")}</h2>
          <p className="m-0" style={{ maxWidth: "28rem" }}>
            {localeText("federnetHandoffErrorText")}
          </p>
          <Link to="/login" className="p-button p-component no-underline">
            {localeText("federnetHandoffGoToLogin")}
          </Link>
        </>
      ) : (
        <>
          <ProgressSpinner style={{ width: "48px", height: "48px" }} strokeWidth="4" />
          <p className="m-0">{localeText("federnetHandoffLoading")}</p>
        </>
      )}
    </div>
  );
};

export default FedernetHandoff;
